import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { readLaboratory } from "../../utils/laboratoryNetwork";
import { apiUrl } from "../apiUrl";

export const getLaboratorios = createAsyncThunk(
  'laboratorios2/listar',
  async (_, { rejectWithValue }) => {
    try {
      const response = await readLaboratory(
        `${apiUrl}/api/v1/laboratorios`
      )
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data)
      }
      return rejectWithValue(error.message);
    }
  }
)

export const registrarLaboratorio = createAsyncThunk(
  "laboratorios2/registro",
  async (data, { rejectWithValue }) => {
    console.log(data)
    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/laboratorios/registrar`,
        data
      );
      return response.data.data;

    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
)

const laboratorios2Slice = createSlice({
  name: "laboratorios2",
  initialState: {
    data: [],
    registrado: null,
    isLoading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //listar laboratorios
      .addCase(getLaboratorios.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLaboratorios.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getLaboratorios.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: 'Fallo al cargar registros de laboratorios'
        };
      })

      //registrar nuevo laboratorio
      .addCase(registrarLaboratorio.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(registrarLaboratorio.fulfilled, (state, action) => {
        state.isLoading = false;
        state.registrado = action.payload;
      })
      .addCase(registrarLaboratorio.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: "Fallo al registrar el laboratorio"
          }
      })
  }
})

export default laboratorios2Slice.reducer;